<template>
  <div :class="`${className}__slider${!show ? ' is-hidden' : ''}`">
    <Copy size="l" centered bold>{{ $t('cs.analysis.packageSelection.kombi.headline') }}</Copy>
    <Row :class="`${className}__sliderRow`" verticalCenter>
      <Col
        :xs="12"
        :m="6"
        :l="3"
        :class="`${className}__recommendation--pflegegeld`"
        :hasMargin="!$matchMedia.l"
      >
        <Copy :right="$matchMedia.l" :centered="!$matchMedia.l" element="div">
          {{ $t('cs.analysis.budgetPackage.recommendation.pflegegeld') }}
        </Copy>
        <Copy
          element="div"
          size="l"
          color="primaryCoral"
          :right="$matchMedia.l"
          :centered="!$matchMedia.l"
          bold
        >
          {{ $t('cs.analysis.budgetPackage.recommendation.row1.pflegegeld') }}
        </Copy>
        <Copy
          element="div"
          size="l"
          color="primaryCoral"
          :right="$matchMedia.l"
          :centered="!$matchMedia.l"
          bold
        >
          {{ formatNumber(userInputFromSlider.pflegegeld.amount, 0) }} €
        </Copy>
      </Col>
      <Col
        :xs="10"
        :xsOffset="1"
        :m="6"
        :mOffset="3"
        :l="6"
        :lOffset="0"
        :class="`${className}__recommendation--chart`"
        center
        :hasMargin="!$matchMedia.l"
      >
        <div :class="`${className}__sliderInputWrapper`">
          <Copy
            :staticClass="`${className}__sliderInputFlag`"
            element="div"
            color="neutral0"
            bold
            :style="{
              left: `calc(${calculatedBasics.pflegegeld.percent.toFixed(0)}% + ${
                (-32 / 100) * calculatedBasics.pflegegeld.percent + 16
              }px)`,
            }"
            noWrap
            v-if="ourRecommendation === 'kombinationsleistung'"
          >
            {{ $t('cs.analysis.budgetPackage.recommendation') }}
          </Copy>
          <input
            ref="input"
            :class="`${className}__sliderInput`"
            type="range"
            min="0"
            max="100"
            step="1.0"
            v-model="userInputValue"
            @change="onChange"
          />
          <Copy :staticClass="`${className}__sliderInputLabel`" element="div" centered bold>
            <span>{{ $t('cs.analysis.packageSelection.kombi.subline') }}</span>
          </Copy>
        </div>
      </Col>
      <Col
        :xs="12"
        :m="6"
        :l="3"
        :class="`${className}__recommendation--pflegesachleistungen`"
        :hasMargin="!$matchMedia.l"
      >
        <Copy :centered="!$matchMedia.l" element="div">
          {{ $t('cs.analysis.budgetPackage.recommendation.pflegesachleistungen') }}
        </Copy>
        <Copy :centered="!$matchMedia.l" element="div" size="l" color="primaryBlue" bold>
          {{ $t('cs.analysis.budgetPackage.recommendation.row1.pflegesachleistungen') }}
        </Copy>
        <Copy :centered="!$matchMedia.l" element="div" size="l" color="primaryBlue" bold>
          {{ formatNumber(userInputFromSlider.pflegesachleistungen.amount, 0) }} €
        </Copy>
      </Col>
    </Row>
  </div>
</template>

<script>
import Copy from '@/objects/Copy';
import Row from '@/components/Grid/Row';
import Col from '@/components/Grid/Col';

import mixin from '@/mixins/careService';
import colors from '@/styles/base/_colors.scss';

import { CARESERVICE_SAVE } from '@/store/actions/careService';

export default {
  name: 'Slider',
  mixins: [mixin],
  props: {
    className: String,
    show: Boolean,
  },
  components: {
    Copy,
    Row,
    Col,
  },
  data() {
    return {};
  },
  watch: {
    show() {
      if (this.careServiceWizardIsFinished) {
        this.userInputValue = this.formatNumber(this.calculatedBasics.pflegegeld.percent, 0, true);
      }
    },
    '$store.state.careService.userInputValue': function () {
      this.updateGradient();
    },
  },
  mounted() {
    this.updateGradient();

    if (this.show) {
      this.userInputValue =
        this.userInputValue || this.formatNumber(this.calculatedBasics.pflegegeld.percent, 0, true);
    }
  },
  methods: {
    updateGradient() {
      this.$refs.input.style.background = `linear-gradient(to right, ${colors.primaryCoral} 0%, ${colors.primaryCoral} ${this.userInputValue}%, ${colors.primaryBlue} ${this.userInputValue}%, ${colors.primaryBlue} 100%)`;
    },

    onChange() {
      this.$store.dispatch(CARESERVICE_SAVE);
      this.$emit('trackSliderMovement');
    },
  },
};
</script>
